//工单
const workorderBox            = () => import('@/components/workorder/workorderBox');
const workorderList           = () => import('@/components/workorder/workorderList');
const workorderInfo           = () => import('@/components/workorder/workorderInfo');

const workorderCategory       = () => import('@/components/workorder/category/workorderCategory');



export default{
    path: '/workorderBox',
    name: 'workorderBox',
    component: workorderBox,
    children: [
        { path: 'workorderList', component: workorderList, name: 'workorderList' },
        { path: 'workorderInfo', component: workorderInfo, name: 'workorderInfo' },
        { path: 'workorderCategory', component: workorderCategory, name: 'workorderCategory' },        
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/workorder.js